import { ProfileState, INIT_PROFILE_STATE } from './profile.state';
import * as ProfileAction from './profile.actions';
import { Action, createReducer, on } from '@ngrx/store';

const _profileReducer = createReducer(

    INIT_PROFILE_STATE,

    on(
        ProfileAction.profileRequestedAction,
        (state, action) => ({
            ...state,
            fetchInProgress: true,
            error: null,
        })
    ),

    on(
        ProfileAction.profileFetchSucceededAction,
        (state, action) => ({
            ...state,
            fetchInProgress: false,
            profileData: action.profileData,
        })
    ),

    on(
        ProfileAction.profileFetchFailedAction,
        (state, action) => ({
            ...state,
            fetchInProgress: false,
            error: action.error
        })
    ),

    on(
        ProfileAction.clearProfileAction,
        (state, action) => ({
            ...INIT_PROFILE_STATE,
        })
    ),

    on(
        ProfileAction.profileSetDefaultAvatarAction,
        (state, action) => ({
            ...state,
            profileData: setDefaultAvatar(state.profileData, action),
        })
    ),

    on(
        ProfileAction.profileSetGPSAction,
        (state, action) => ({
            ...state,
            profileData: enableGPS(state.profileData, action),
        })
    ),

    on(
        ProfileAction.profileSetLastNameChangeAction,
        (state, action) => ({
            ...state,
            profileData: UpdateLastNameChanged(state.profileData),
        })
    ),

    on(
        ProfileAction.updateCurrenciesActio,
        (state, action) => ({
            ...state,
            profileData: UpdateCurrencies(state.profileData, action),
        })
    ),

    on(
        ProfileAction.setProfileTagsAction,
        (state, action) => ({
            ...state,
            tags: action.tags,
        })
    ),

    on(
        ProfileAction.setExperienceAction,
        (state, action) => ({
            ...state,
            experience: action.experienceData,
        })
    ),

    on(
        ProfileAction.updateNextDailyAndNextStreakAction,
        (state, action) => {
            return {
                ...state,
                timestamps: action.timestamps
            }
        }
    ),

    on(
        ProfileAction.activateProfileComponent,
        (state, action) => ({
            ...state,
            activeComponent: action.component,
        })
    ),

    on(
        ProfileAction.acceptTermsOnRegistrationPage,
        (state, action) => {
            return {
                ...state,
                termsAcceptedOnRegistration: true,
            }
        }
    ),
)

function setDefaultAvatar(profile: any, payload: any) {
    profile.defaultAvatar = payload.defaultAvatar;
    return profile;
}

function enableGPS(profile: any, payload: any) {
    profile.gpsStatus = payload.gps;
    return profile;
}

function UpdateLastNameChanged(profile: any) {
    profile.lastNameChange = new Date();
    return profile;
}

function UpdateCurrencies(profile: any, payload: any) {
    profile.diamonds = payload.diamonds;
    profile.golds = payload.golds;
    return profile;
}

export function profileReducer(state: ProfileState, action: Action) {
    return _profileReducer(state, action);
}
